// Bootstrap Imports

import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import ScrollBarHelper from 'bootstrap/js/src/util/scrollbar';

/*******************************************
 *  Helper Functions
 *******************************************/

// Handles flash of unstyled content.
function fouc() {
	const html = document.querySelector('html');
	html.classList.remove('no-js');
	html.classList.add('js');
}

// Optimize the scroll events for better browser performance.
//
// Broadcasts optimizedScroll event on the window.
// Use the same way you would add a window scroll listener.
// window.on('optimizedScroll', ...);
function optimizeScroll() {
	let scrollWaiting = false,
		endScrollHandle;
	window.addEventListener('scroll', () => {
		if (scrollWaiting) {
			return;
		}
		scrollWaiting = true;

		// clear previous scheduled endScrollHandle
		clearTimeout(endScrollHandle);

		window.dispatchEvent(new Event('optimizedScroll'));

		setTimeout(function () {
			scrollWaiting = false;
		}, 100);

		// schedule an extra execution of scroll() after 200ms
		// in case the scrolling stops in next 100ms
		endScrollHandle = setTimeout(function () {
			window.dispatchEvent(new Event('optimizedScroll'));
		}, 200);
	});
}

function mainNavigationScroll() {
	window.addEventListener('optimizedScroll', () => {
		const scrollY = window.scrollY;
		const masthead = document.getElementById('masthead');

		if (scrollY > 68) {
			masthead.classList.remove('top');
		} else {
			masthead.classList.add('top');
		}
	});
}

function mainNavigation() {
	mainNavigationScroll();

	const navCollapseEl = document.getElementById('main-menu-collapse');
	// const masthead = document.getElementById('masthead');
	const body = document.querySelector('body');
	const scrollBar = new ScrollBarHelper();

	// Use Popper on navbar dropdowns
	Dropdown.prototype._detectNavbar = function () {
		// TODO only allow popper on larger devices.
		// Needs to support changing device sizes.
		return false;
	};

	// Solution to allow nested dropdowns with BSv5
	// https://jsfiddle.net/dallaslu/mvk4uhzL/
	const SHOW_CLASS_NAME = 'has-child-dropdown-show';
	Dropdown.prototype.toggle = (function (_orginal) {
		return function () {
			document
				.querySelectorAll('.' + SHOW_CLASS_NAME)
				.forEach(function (e) {
					e.classList.remove(SHOW_CLASS_NAME);
				});
			let dd = this._element
				.closest('.dropdown')
				.parentNode.closest('.dropdown');
			for (
				;
				dd && dd !== document;
				dd = dd.parentNode.closest('.dropdown')
			) {
				dd.classList.add(SHOW_CLASS_NAME);
			}
			return _orginal.call(this);
		};
	})(Dropdown.prototype.toggle);

	document.querySelectorAll('.dropdown').forEach(function (dd) {
		dd.addEventListener('hide.bs.dropdown', function (e) {
			if (this.classList.contains(SHOW_CLASS_NAME)) {
				this.classList.remove(SHOW_CLASS_NAME);
				e.preventDefault();
			}
			e.stopPropagation(); // do not need pop in multi level mode
		});
	});

	// Opt-in enable hover toggle on dropdowns
	// Add .dropdown-hover to the .dropdown, or add .dropdown-hover-all to a parent element.
	//
	// Note: it is generally a better idea to enable dropdowns on click.
	document
		.querySelectorAll('.dropdown-hover, .dropdown-hover-all .dropdown')
		.forEach(function (dd) {
			const animationFadeUp = (
				element,
				position,
				gap = 20,
				duration = 0.3
			) => {
				element.style.opacity = 1;
				element.style.transform = `translateY(${position}px)`;

				gsap.timeline().from(element, {
					duration,
					opacity: 0,
					y: position + gap,
				});
			};

			dd.addEventListener('mouseenter', function (e) {
				const toggle = e.target.querySelector(
					':scope>[data-bs-toggle="dropdown"]'
				);
				if (!toggle.classList.contains('show')) {
					const offset =
						Dropdown.getOrCreateInstance(toggle)._element
							.offsetHeight;

					const dropdownMenu =
						e.target.querySelector('.dropdown-menu');

					Dropdown.getOrCreateInstance(toggle).toggle();
					dd.classList.add(SHOW_CLASS_NAME);
					Dropdown.clearMenus();

					animationFadeUp(dropdownMenu, offset);
				}
			});
			dd.addEventListener('mouseleave', function (e) {
				const toggle = e.target.querySelector(
					':scope>[data-bs-toggle="dropdown"]'
				);
				if (toggle.classList.contains('show')) {
					Dropdown.getOrCreateInstance(toggle).toggle();
				}
			});
			// Redirect to link if it exists/is valid.
			dd.addEventListener('click', function () {
				const toggle = this.querySelector(
					':scope>[data-bs-toggle="dropdown"]'
				);
				if (!toggle.getAttribute('href').lastIndexOf('#', 0) !== 0) {
					window.location.href = toggle.getAttribute('href');
				}
			});
		});

	// Prevent scroll while open
	navCollapseEl.addEventListener('show.bs.collapse', function () {
		scrollBar.hide();
		body.style.paddingRight = 0;
	});
	navCollapseEl.addEventListener('hide.bs.collapse', function () {
		scrollBar.reset();
	});

	// Close main navigation on resize
	window.addEventListener('resize', function () {
		if (
			typeof navCollapseEl !== 'undefined' &&
			navCollapseEl.classList.contains('show')
		) {
			const navCollapse = Collapse.getInstance(navCollapseEl);
			navCollapse.hide();
		}
	});
}

/*******************************************
 *  Custom Functions for the theme
 *******************************************/
function easyNotificationBarPosition() {
	const notification = document.querySelector(
		'.easy-notification-bar.easy-notification-bar--sticky'
	);

	const header = document.getElementById('masthead');

	if (!notification && !header) return false;

	notification.style.display = 'flex';

	const adjustMenuPosition = () => {
		const height = notification.offsetHeight;
		header.style.marginTop = `${height}px`;
	};

	adjustMenuPosition();
	window.onresize = adjustMenuPosition;
}

/**
 * On Loads
 */
document.addEventListener('DOMContentLoaded', () => {
	fouc();
	optimizeScroll();
	mainNavigation();
	mainNavigationScroll();

	easyNotificationBarPosition();
});
